import { useState } from 'react';

// Import utilities
import { useQuery } from 'react-query';
import { useAuth } from 'components/utilities';

// Import services
import services from 'services/services';

// Import variables
import {
	GEO_LOCK_MODAL_TYPES,
	KEEP_GEOLOCK_CACHE_TIME,
	KEEP_GEOLOCK_STALE_TIME,
	VERIFICATION
} from 'helpers/variables';

import {
	GEO_LOCK_QUERY_KEYS,
	GET_GEO_LOCK_API,
	GET_IS_EOG_LOCATION_API,
	GET_IS_POLISH_LOCATION_API
} from 'helpers/api';

// API returns data if user's IP is in the allowed region and throws an error otherwise.
// React query do not cache errors or data change from invalid request attempts (undefined)
// To combat that, this function always resolves a cachable data, even though the syntax is awful
// There might be a smarter and more elegant way, but for now it works
const fetchGeoLock = (type, userVerificationState, setIsEOG) => async () => {
	try {
		if (type === GEO_LOCK_MODAL_TYPES.PURCHASE) {
			const {
				data: { message: isPurchase }
			} = await services.get(GET_GEO_LOCK_API);

			if (!isPurchase) {
				return Promise.resolve(false);
			}
		}

		if (type === GEO_LOCK_MODAL_TYPES.WATCH) {
			const {
				data: { message: isPolish }
			} = await services.get(GET_IS_POLISH_LOCATION_API);

			const {
				data: { message: isEOG }
			} = await services.get(GET_IS_EOG_LOCATION_API);

			if (!isPolish) {
				if (!isEOG) {
					setIsEOG(isEOG);
					return Promise.resolve(false);
				} else if (userVerificationState !== VERIFICATION.VERIFIED) {
					return Promise.resolve(false);
				}
			}
		}

		return Promise.resolve(true);
	} catch (e) {
		return Promise.resolve(false);
	}
};

const useGeoLockModal = (type, userVerificationState) => {
	const [isEOG, setIsEOG] = useState(true);

	const { isAuth } = useAuth();

	const { isLoading, data } = useQuery({
		queryKey: GEO_LOCK_QUERY_KEYS[type],
		queryFn: fetchGeoLock(type, userVerificationState, setIsEOG),
		staleTime: KEEP_GEOLOCK_STALE_TIME,
		cacheTime: KEEP_GEOLOCK_CACHE_TIME,
		enabled: isAuth
	});

	const handleOnBlock = (cb) => (e) => {
		if (!data && !isLoading) {
			e && e.preventDefault();
			isAuth && cb();
		}
	};

	const handleOnPass = (cb) => () => data && !isLoading && cb?.();

	return {
		isLoading,
		block: handleOnBlock,
		pass: handleOnPass,
		isEOG: isEOG
	};
};

export default useGeoLockModal;
